import React from "react";
import {Box, Button, Grid, Paper, TextField, Typography} from "@mui/material";

export default function ServerSettingsForm({ settings, handleChange, openDialog }) {
    return (
        <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3 }}>
            <Typography variant="h5" fontWeight={800} gutterBottom>Параметры сервера</Typography>
            <Typography color="text.secondary" mb={3}>
                Основные игровые и сетевые настройки сервера.
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <TextField fullWidth label="Название" value={settings.title || ''} onChange={(e) => handleChange('title', e.target.value)} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField fullWidth label="IP адрес сервера" value={settings.address || ''} onChange={(e) => handleChange('address', e.target.value)} />
                </Grid>
                <Grid item xs={12}>
                    <TextField fullWidth label="Описание" value={settings.description || ''} onChange={(e) => handleChange('description', e.target.value)} multiline minRows={3} />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField fullWidth label="Размер карты" value={settings.map_size || ''} onChange={(e) => handleChange('map_size', e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField fullWidth label="Максимум игроков" value={settings.max_players || ''} onChange={(e) => handleChange('max_players', e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField fullWidth label="SEED карты" value={settings.seed || ''} onChange={(e) => handleChange('seed', e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField fullWidth label="Игровой порт" value={settings.game_port || ''} onChange={(e) => handleChange('game_port', e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField fullWidth label="RCON порт" value={settings.rcon_port || ''} onChange={(e) => handleChange('rcon_port', e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField fullWidth label="RCON пароль" value={settings.rcon_password || ''} onChange={(e) => handleChange('rcon_password', e.target.value)} type="password" />
                </Grid>
                <Grid item xs={12}>
                    <TextField fullWidth label="Картинка сервера (ссылка)" value={settings.image_url || ''} onChange={(e) => handleChange('image_url', e.target.value)} />
                </Grid>
            </Grid>

            {settings.image_url && (
                <Box mt={2.5}>
                    <Typography variant="subtitle2" mb={1}>Предпросмотр</Typography>
                    <Box
                        component="img"
                        src={settings.image_url}
                        alt="Server Preview"
                        sx={{ width: '100%', maxWidth: 520, maxHeight: 260, objectFit: 'cover', borderRadius: 3 }}
                    />
                </Box>
            )}

            <Button variant="contained" onClick={() => openDialog("save")} sx={{ mt: 3, width: { xs: '100%', sm: 'auto' } }}>
                Сохранить изменения
            </Button>
        </Paper>
    );
}
